import { createSlice } from '@reduxjs/toolkit';
import { selectUserIsRoot } from 'slices/auth.slice';
import type { TRootState } from 'slices/store';

type TState = {
  /**
   * Used during transition for Root users to enable or disable experimental AOP navigation and micro frontends
   */
  useAopTopbar: boolean | null;
};

const slice = createSlice({
  name: 'aopUserConfig',
  initialState: { useAopTopbar: null } as TState,
  reducers: {
    toggleUseAopTopbar: (state) => {
      state.useAopTopbar = !state.useAopTopbar;
    },
  },
});

export const { toggleUseAopTopbar } = slice.actions;
export const selectUseAopTopbar = (state: TRootState) => {
  if (!selectUserIsRoot(state) && !import.meta.env.DEV) return null;

  return state.aopUserConfig.useAopTopbar;
};

export default slice.reducer;
